import { userColorDetails } from './utils/user.color.details.js';
import * as constants from './utils/constants.js';
/**
 * Summary: this method is used to return users color based on his userId
 * @since      1.4.0
 * @access     public
 * @param {type}   var           userId : value should be a number otherwise a default color will be returned.
 * @return {object} Returns object which consists background color and text color supporting the background color.
 */
 const getUserColor = (userId) => {
    if(isNaN(userId)){
        return constants.DEFAULT_COLOR
    } else {
        const colorsArr = userColorDetails.colorsArray;
        return colorsArr[ userId % colorsArr.length ];
    }
}

export const userColors = {
    getUserColor
}